import env from "@/env";
import { get } from "@/utils/request";
import { SoilBaseInfoVO } from "../../../src/api/osm-lib/lsc-tuliu-center-soil";
import { PagingParameters, WithPagingData } from "./util";

export type LandInfo = Omit<SoilBaseInfoVO, "id" | "locationId" | "appSrc"> & {
  id: number;
  locationId: number;
  hasBusinessInfo: number;
  hasTransferInfo: number;
};
export type StatefulLandInfo = LandInfo & {
  syncPlatformName?: string; // 同步平台
  allowanceStatus: number; // 补贴状态
  status: number; // 出租状态
  reason?: string;
  cropNames?: string;
};
export type LngLatToAddress = {
  lng: number;
  lat: number;
};

/**
 * 获取土地列表
 * @param type 1 未提交经营信息置顶 2 未提交出租信息置顶
 * @returns
 */
export const getLandListByType = (type: 1 | 2) => {
  return get<StatefulLandInfo[]>({
    baseURL: env.centerUrl,
    url: "/ddd/user/soil/datas",
    data: {
      type,
    },
  });
};

/**
 * 获取土地列表
 * @param type 1-未奖励 2-已奖励 3-未出租 4-招租中 5-已出租
 * @returns
 */
export const getStatefulLandListByType = (
  data: PagingParameters & { type: number }
) => {
  return get<WithPagingData<StatefulLandInfo[]>>({
    baseURL: env.centerUrl,
    url: "/ddd/user/soil/page",
    data,
  });
};

/**
 * 获取用户地块列表
 * @returns
 */
export const getSoilStatistics = () => {
  return get<{ coordinatesList: string[] }>({
    baseURL: env.centerUrl,
    url: "/ddd/user/soil/home/getSoilStatistics",
  });
};

/**
 * 获取经纬度转地区信息
 * @returns
 */
export const getLngLatToAddress = (data: LngLatToAddress) => {
  return get<{ address: string; locInfo: { city: { name: string } } }>({
    baseURL: env.centerUrl,
    url: "/soil/locInfo/coordinateTransferToLocInfo",
    data,
  });
};

/**
 * 获取城市列表
 * @returns
 */
export type CityItem = {
  name: string;
  latitude: string;
  longitude: string;
  initialPy: string;
};
export const getAllCityBySort = (data: { name: string }) => {
  return get<CityItem[]>({
    baseURL: env.centerUrl,
    url: "/soil/locInfo/getSortCityList",
    data,
  });
};
